import React from 'react';
import styles from './ApiSecretKey.module.scss';
import { USER_BASE_URL } from '../../../../Utils/Endpoints';


const CredentialCard = ({ label, value, onCopy, isCopied, status, viewSecretKeyLink }) => {
    return (
        <div className={styles.credentialCard}>
            <div className={styles.cardHeader}>
                <span className={styles.cardLabel}>{label}</span>
                {status && (
                    <div className={styles.statusActive}>
                        <i className="material-icons">check_circle</i>
                        <span>{status}</span>
                    </div>
                )}
            </div>
            <div className={styles.cardBody}>
                <span className={styles.cardValue}>{value}</span>
                {onCopy && (
                    <div className={styles.copyContainer}>
                        {isCopied ? (
                            <span className={styles.copySuccess}>Copied!</span>
                        ) : (
                            <i className={`material-icons ${styles.copyIcon}`} onClick={() => onCopy(value)}>
                                content_copy
                            </i>
                        )}
                    </div>
                )}
            </div>
            {viewSecretKeyLink && (
                <div className={styles.cardFooter}>
                    <a href={USER_BASE_URL + viewSecretKeyLink} target="_blank" rel="noopener noreferrer" className={styles.viewSecretLink}>
                        View Secret Key
                    </a>
                </div>
            )}
        </div>
    );
};

export default CredentialCard;